type AuthRequiredListener = () => void;

const listeners = new Set<AuthRequiredListener>();

// Lets non-React modules (api.ts) signal React state (AppProvider) that
// interactive re-authentication is required.
export function onAuthRequired(listener: AuthRequiredListener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function notifyAuthRequired(): void {
    listeners.forEach(listener => listener());
}
